<template>
  <div class="nav">
    <img @click="backToHome" alt class="logo" src="../assets/images/logo.png"/>
    
    <ul>
      <li :key="index" v-for="(item, index) in mainNaviList">
        <router-link :class="{active: index == mainIndex}"
                     :to="item.subNavList != null ? `${item.link}${item.link === '/product/'?1:0}` : `${item.link}`">
          {{item.name}}
        </router-link>
        <ul v-if="item.subNavList != null">
          <li :key="s_index" @click="ulClick(s_index,item.link)" v-for="(s_item, s_index) in item.subNavList">
            <router-link :to="`${item.link}${item.link === '/product/'?s_index +1:s_index}`">{{s_item}}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "navBar",
    props: ['mainIndex'],
    data() {
      return {
        mainNaviList: [
          {
            name: '关于我们',
            subNavList: null,
            link: '/contactUs'
          },
          {
            name: '加入我们',
            subNavList: null,
            link: '/joinUs'
          },
          {
            name: '金融解决方案',
            subNavList: ['定制专享', '基础设施', '软件平台', '第三方应用接入'],
            link: '/solution/'
          },
          {
            name: '产品和服务',
            subNavList: ['金融交易系统', '清算系统', '远程开户系统', '深度行情数据'],
            link: '/product/'
          },
          {
            name: '首页',
            subNavList: null,
            link: '/'
          }
        ]
      };
    },
    mounted() {
    },
    methods: {
      ulClick(index, link) {
        console.log(link);
        if (link === "/product/") {
          this.$emit("anchorJump", index + 1);
        } else {
          this.$emit("anchorJump", index);
        }
      },
      backToHome() {
        this.$router.push("/");
      }
    }
  };
</script>


<style scoped>
  .logo {
    width: 202px;
    position: absolute;
    left: 48px;
    top: 24px;
    cursor: pointer;
  }
  
  .nav a {
    text-decoration: none;
  }
  
  .nav {
    background: #1f293b;
    box-shadow: 0px 0px 15px 1px rgba(35, 24, 21, 0.1);
    position: fixed;
    padding-right: 78px;
    width: 100%;
    z-index: 9999;
  }
  
  .nav > ul {
    position: relative;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .nav > ul > li > ul {
    position: absolute;
    left: -20px;
    padding: 0;
    margin: 0;
    list-style: none;
    z-index: 999;
    border-radius: 5px;
  }
  
  .nav > ul > li > ul > li:hover > a {
    color: #ffa63e !important;
  }
  
  .nav > ul > li:hover > ul li a {
    opacity: 1;
    height: 49px;
    transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    -moz-transition: all 0.3s linear;
    -webkit-transition: all 0.3s linear;
  }
  
  .nav > ul > li > ul a {
    display: block;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    
    color: #fff;
    width: 150px;
    
    background: #1f293b;
    border-bottom: 1px solid #595959;
    text-align: center;
    height: 0;
    overflow: hidden;
    opacity: 0;
    transition: all 0.3s linear 0.2s;
    -o-transition: all 0.3s linear 0.2s;
    -moz-transition: all 0.3s linear 0.2s;
    -webkit-transition: all 0.3s linear 0.2s;
  }
  
  .nav > ul > li {
    float: right;
    position: relative;
  }
  
  .nav > ul > li > a {
    font-size: 16px;
    display: block;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 78px;
    padding: 0 19px;
  }
  
  .nav > ul > li:hover > a {
    transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    -moz-transition: all 0.3s linear;
    -webkit-transition: all 0.3s linear;
    color: #ffbe21 !important;
  }
  
  .active {
    color: #ffa63e !important;
  }
  
  /*1280的设备屏幕*/
  @media (max-width: 1439px) {
    .nav > ul > li > a {
      font-size: 12px;
    }
    .logo {
      width: 170px;
    }
    .nav > ul > li:hover > ul li a {
      height: 40px;
    }
    .nav > ul > li > ul a{
      font-size: 12px;
      line-height: 40px;
    }
  }
  
  /*1440的设备屏幕*/
  @media (min-width: 1440px) and (max-width: 1679px) {
    .nav > ul > li > a {
      font-size: 14px;
    }
    .logo {
      width: 180px;
    }
    .nav > ul > li:hover > ul li a {
      height: 40px;
    }
    .nav > ul > li > ul a{
      font-size: 12px;
      line-height: 40px;
    }
  }
  
  /*1680的设备屏幕*/
  @media (min-width: 1680px) and (max-width: 1919px) {
    .nav > ul > li > a {
      font-size: 14px;
    }
    .logo {
      width: 190px;
    }
  }
  
  /*1920的设备屏幕*/
  @media (min-width: 1920px) {
  }

</style>


// WEBPACK FOOTER //
// src/components/navBar.vue